// Helper to compare two images
export function areImagesEquals(firstImage, secondImage) {
    if (!firstImage || !secondImage)
        throw new Error(
            'Error: at least one of the image to compare is empty or not defined',
        );

    // Required fields must be present on both images (not null/undefined)
    if (
        firstImage.id == null ||
        secondImage.id == null ||
        firstImage.path == null ||
        secondImage.path == null ||
        firstImage.position == null ||
        secondImage.position == null
    )
        return false;

    // If one of the main field is diff return false
    if (firstImage.id !== secondImage.id) return false;
    if (firstImage.path !== secondImage.path) return false;
    if (firstImage.position !== secondImage.position) return false;

    return true;
}

// Helper to compare two image lists
export function areImageListsEquals(firstImageList, secondImageList) {
    // If both list are empty
    if (!firstImageList.length > 0 && !secondImageList.length > 0) return true;

    // If the lists are not the same size
    if (firstImageList.length !== secondImageList.length) return false;

    // For each element of the lists
    for (let i = 0; i < firstImageList.length; i++) {
        // If one set of image is not equal
        try {
            if (!areImagesEquals(firstImageList[i], secondImageList[i]))
                return false;
        } catch (err) {
            console.error(
                `Error while comparing images at index ${i}\nError message: ${err.message}`,
            );
            return false;
        }
    }

    return true;
}
